import { Component, ViewChild, Input, ElementRef, Output, EventEmitter } from '@angular/core';
import * as $ from 'jquery'

@Component({
  selector: 'rmt-password',
  templateUrl: 'rmt-password.html'
})
export class RmtPasswordComponent {
  @ViewChild('container', { read: ElementRef }) container;
  @ViewChild('input') input;
  @ViewChild('passwordok', { read: ElementRef }) passwordok;
  @ViewChild('passwordcriteria', { read: ElementRef }) passwordcriteria;
  @ViewChild('hint', { read: ElementRef }) hint;
  @Input() passwordHint: boolean = false;
  @Output() ionChange = new EventEmitter<any>();
  @Output() focusEmitter = new EventEmitter<any>();
  @Output() blurEmitter = new EventEmitter<any>();
  @Input() passwordId:string='';
  @Input() autocompleteName:string='off';
  @Input() showPassword: boolean = false;
  @Input() showPasswordIcon: boolean = true;
  @Input() changeInputType: boolean = false;
  @Input() keepPasswordHint: boolean = false;

  constructor() {
  }

  ngAfterViewInit() {
    if (this.passwordHint) {
      const item = $(this.container.nativeElement).parents('.item');
      if (item && item.length > 0)
        item.get(0).style.maxHeight = 'none';
    }
  }

  public togglePassword() {
    this.changeInputType = false;
    this.showPassword = !this.showPassword;
  }
  
  public getInputType() {
    // if we're using autocomplete and are on iOS we have some weird behaviour with the autofill manager working only 
    // properly for the email field when this is clear-text - hence in that case when no password is entered we keep it as clear-text
    if(this.changeInputType && this.input && this.input.value.length === 0) {
      return 'text';
    }
    else if (this.showPassword) {
      return 'text';
    }
    return 'password';
  }

  criteriaLength() {
    let result = false;
    if (this.input && this.input.value && this.input.value.length >= 8)
      result = true;
    return this.getCriteria(result);
  }

  criteriaLetter() {
    let result = false;
    if (this.input && this.input.value) {
      const reg = /^(?=.*[A-Z]).{1,}$/;
      if (reg.test(this.input.value))
        result = true;
    }    
    return this.getCriteria(result);
  }
  criteriaLowerCaseLetter() {
    let result = false;
    if (this.input && this.input.value) {
      const reg = /^(?=.*[a-z]).{1,}$/;
      if (reg.test(this.input.value))
        result = true;
    }    
    return this.getCriteria(result);
  }
  criteriaNumber() {
    let result = false;
    if (this.input && this.input.value) {
      const reg = /^(?=.*[0-9]).{1,}$/;
      if (reg.test(this.input.value))
        result = true;        
    }
    return this.getCriteria(result);
  }

  getCriteria(result) {
    if (this.passwordcriteria && this.passwordok) {
      let overallresult = result;
      if (overallresult && this.passwordcriteria.nativeElement.getElementsByClassName('criteria-nok').length > 0)
        overallresult = false;
      if (overallresult) {
        if(!this.keepPasswordHint) {
          this.passwordcriteria.nativeElement.style.opacity = 0.0;
          this.passwordok.nativeElement.style.opacity = 1.0;
        }
      }
      else {
        this.passwordcriteria.nativeElement.style.opacity = 1.0;
        this.passwordok.nativeElement.style.opacity = 0.0;
      }
    }
    
    if (result)
      return 'criteria criteria-ok';
    return 'criteria criteria-nok';
  }

  getValue() {
    if (this.input)
      return this.input.value;
    return null;
  }

  changed(ev) {
    this.ionChange.emit(ev);
  }

  focus() {
    this.focusEmitter.emit();
  }

  blur() {
    this.blurEmitter.emit();
  }

  setInputFocus() {
    this.input.setFocus();
  }
}


// WEBPACK FOOTER //
// ./src/components/rmt-password/rmt-password.ts